import { FC } from "react";

interface ClearProps {}

const Clear: FC<ClearProps> = (props: ClearProps) => {
    return (
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M1.39953 13.6538L0.345703 12.6L5.9457 7.00002L0.345703 1.40002L1.39953 0.346191L6.99953 5.94619L12.5995 0.346191L13.6534 1.40002L8.05335 7.00002L13.6534 12.6L12.5995 13.6538L6.99953 8.05384L1.39953 13.6538Z"
                fill="black"
            />
        </svg>
    );
};

export default Clear;
